export enum PuzzleSortField {
	name = 'name',
	publishedAt = 'publishedAt',
	plays = 'plays',
	likes = 'likes',
}
